<template>
  <div :class="componentClassName">
    <a-brand-logo variant="horizontal" class="t-application-invite-user-registration-complete__logo" />
    <div class="t-application-invite-user-registration-complete__content">
      <a-application-complete-sign class="t-application-invite-user-registration-complete__image" />
      <a-heading
        heading="申し込みが完了しました"
        color="primary"
        size="large"
        class="t-application-invite-user-registration-complete__heading"
      />
      <a-text class="t-application-invite-user-registration-complete__text">
        このたびはお申し込みありがとうございました。<br />
        契約者様のご本人確認をお待ちください。
      </a-text>
      <a-button
        id="goTop"
        variant="block"
        color="primary"
        label="サイトトップへ"
        class="t-application-invite-user-registration-complete__button"
        @click="handleGoToHome"
      />
    </div>
    <o-global-footer class="t-application-invite-user-registration-complete__footer" />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AApplicationCompleteSign from '@/components/atoms/application-complete-sign';
import ABrandLogo from '@/components/atoms/brand-logo';
import AButton from '@/components/atoms/button';
import AHeading from '@/components/atoms/heading';
import AText from '@/components/atoms/text';
import OGlobalFooter from '@/components/organisms/global-footer';
import { LP_URL, SIGNUP_RELIEF_MEASURES_PATH } from '@/libs/constants';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

import { utils } from '@/common/utils.js';

export default {
  name: 't-application-invite-user-registration-complete',
  components: {
    AApplicationCompleteSign,
    ABrandLogo,
    AButton,
    AHeading,
    AText,
    OGlobalFooter,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // handleGoToHome: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      tmpUUID: '',
      tmpYMD: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-registration-complete');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: SIGNUP_RELIEF_MEASURES_PATH });
      return; // #2314
    }
    await this.deleteAllCookies();
  },
  methods: {
    handleGoToHome() {
      window.location.href = LP_URL;
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('処理'));
        });
    },
    deleteAllCookies: async function () {
      await this.postRequest('/signup/deleteAllCookies')
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.$router.push({ path: SIGNUP_RELIEF_MEASURES_PATH });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('処理'));
        });
    },
  },
};
</script>
